$(document).ready(function () {
  $('.sidebar-nav__main-links-hover .search_by_id').click(function () {
    $('.sidebar-nav__close-button').click()
  })

  // Mobile member scroll bar
  $('.header--member__navigation').scroll(function () {
    $(this).scrollLeft() > 30 ? $('.header--member i').fadeOut() : $('.header--member i').fadeIn()
  })

  // Mobile scroll
  if ($('.js-header-subnav').length) {
    let headerSubNavStateShown = true
    function changeHeaderState(state) {
      if (state === 'in' && !headerSubNavStateShown) {
        $('.js-header-subnav').fadeIn()
        headerSubNavStateShown = true
      } else if (state === 'out' && headerSubNavStateShown) {
        $('.js-header-subnav').fadeOut()
        headerSubNavStateShown = false
      }
    }

    $(window).scroll(function () {
      if ($(this).scrollTop() > 30 && $(window).width() < 484) {
        changeHeaderState('out')
      } else {
        changeHeaderState('in')
      }
    })
  }

  //set off counter when impact panel in in view
  if ($('.dashboards-show').length > 0) {
    var elemTop = $('.homepage__impact__stats-container h3').offset().top
    var counted = false
    isImpactVisiable()
  }

  function isImpactVisiable() {
    var docViewTop = $(window).scrollTop()
    var docViewBottom = docViewTop + $(window).height()
    if (elemTop <= docViewBottom && counted == false) {
      count()
    }
  }

  function count() {
    counted = true
    $('.counter').each(function () {
      var $this = $(this)
      var countTo = $this.data('count')

      $({ countNum: $this.text() }).animate(
        {
          countNum: countTo,
        },
        {
          duration: 1500,
          easing: 'swing',
          step: function () {
            $this.text(Math.floor(this.countNum).toLocaleString())
          },
          complete: function () {
            $this.text(this.countNum.toLocaleString())
          },
        }
      )
    })
  }

  $(window).scroll(function () {
    isImpactVisiable()
  })
})
